/**
 * JsonLd — render a JSON-LD <script> tag for structured data (schema.org).
 *
 * Usage:
 *   <JsonLd data={{
 *     "@context": "https://schema.org",
 *     "@type": "FAQPage",
 *     mainEntity: [...]
 *   }} />
 *
 * Notes:
 *   - We use a plain <script> tag rather than react-helmet to keep the
 *     dependency footprint small. JSON-LD inside <body> is valid per
 *     Google's SEO docs (https://developers.google.com/search/docs/appearance/structured-data).
 *   - `dangerouslySetInnerHTML` is required to emit the raw JSON. We
 *     sanitize by JSON.stringify so user-influenced strings cannot
 *     inject script content.
 */
export default function JsonLd({ data }) {
  if (!data) return null;
  return (
    <script
      type="application/ld+json"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}
